class AssignUsers {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, ASSIGN_USER_CONSTANT, $mdMedia, $mdDialog, $stateParams) {
        this.scope = $scope;
        this.state = $state;
        let authoringData = localStorageService.get("authoringData")
        let authoring = {
            class_id: authoringData.class_id,
            batch_id: authoringData.batch_id,
            subject_id: authoringData.subject_id,
            school_id: authoringData.school_id,
            curriculum_id: authoringData.curriculum_id,
            subject: authoringData.subject,
            class: authoringData.class,
            batch: authoringData.batch,
            session_id: authoringData.session_id,
            session: authoringData.session,
            curriculum: authoringData.curriculum,
            academic_year: authoringData.academic_year
        }

        //Boolean - Assign all students or  not
        $scope.isAllStudents = false;

        //Boolean - Assign all groups or not
        $scope.isAllGroups = false;

        //[Object] - List of all students in the class
        $scope.allStudents = [];

        //[Object] - List of groups
        $scope.groupList = [];
        let userId = localStorageService.get('user_id')
        let planId = $state.params.planId

        //Object - basic academic details
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            if (authoring) {
                authoring['user_id'] = userId
                getGroupList()
                getAllStudents()
            } else {
                $state.go("authdashboard")
            }
        }

        //Object - Assigned users
        $scope.assignedUsers = {};

        //[Object] - Selected Groups
        $scope.selectedGroupList = [];

        //[Object] - Selected Students
        $scope.selectedStudentList = [];

        $scope.isServerCall = false;

        if ($stateParams.previousState.state !== "") {
            localStorageService.set('assignUserHistory', $stateParams.previousState);
            //Object - State param
            $scope.previousState = $stateParams.previousState;
        } else {
            $scope.previousState = localStorageService.get('assignUserHistory')
        }

        if ($scope.previousState == null || $scope.previousState == undefined || $scope.previousState == '') {
            $state.go('viewTeachingPlan', {
                planId: $stateParams.planId
            });
        }
        function getAllStudents() {
            authService.callAPI(ASSIGN_USER_CONSTANT.API_GET_STUDENT_LIST, "POST", authoring, function(response) {
                if (response && response.result && response.result.data) {
                    if (response.result.data.data.length > 0)
                        $scope.allStudents = response.result.data.data
                    $scope.$apply()
                }
            })
        }

        function getGroupList() {
            authService.callAPI(ASSIGN_USER_CONSTANT.API_GET_GROUP_DETAILS, "POST", authoring, function(response) {
                if (response && response.result && response.result.data) {
                    let groupList = response.result.data.data
                    authService.callAPI(ASSIGN_USER_CONSTANT.API_GET_ASSIGNED_USERS + planId, "POST", {}, function(response) {
                        if (response && response.result && response.result.data) {
                            let result = response.result.data.data
                            if (result && result.type == "all") {
                                let list = []
                                _.each($scope.allStudents, function(student) {
                                    list.push({
                                        _id: student.user_id
                                    });
                                })
                                $scope.selectedStudentList = list;
                                $scope.isAllStudents = true;
                            }

                            _.each(groupList, function(group) {
                                let isLeader = false;
                                let leaderName = '';
                                _.each(group.students, function(student) {
                                    if (student.leader) {
                                        isLeader = true;
                                        if (leaderName === '')
                                            leaderName = student.name;
                                        else
                                            leaderName += ", " + student.name;
                                    }
                                })
                                group.isLeader = isLeader;
                                group.leaderName = leaderName;
                                group.isSelected = false;
                                if (result && result.type == "group") {
                                    let assignGroup = _.find(result.list, function(obj) {
                                        return group._id == obj._id
                                    })
                                    if (assignGroup) {
                                        group.isSelected = true;
                                        $scope.selectedGroupList.push({
                                            _id: group._id
                                        });
                                    }
                                }
                            })
                            if (result && result.type == "group" && result.list.length == groupList.length)
                                $scope.isAllGroups = true
                            $scope.groupList = groupList
                        }
                        _.defer(function() {
                            $scope.$apply();
                        });;
                    })
                }
            })
        }

        $scope.allStudentsSelected = () => {
            $scope.isServerCall = true;
            $scope.selectedGroupList = [];
            $scope.isAllGroups = false;
            _.each($scope.groupList, function(group) {
                group.isSelected = false;
            })
            if ($scope.selectedStudentList.length === 0) {
                //[Object] - List of student Ids
                let list = [];
                _.each($scope.allStudents, function(student) {
                    list.push({
                        _id: student._id,
                        name: student.name
                    });
                })
                $scope.selectedStudentList = list;
                $scope.selectedGroupList = [];
            } else
                $scope.selectedStudentList = []

        }

        $scope.allGroupSelected = () => {
            $scope.isServerCall = true;
            $scope.selectedGroupList = [];
            $scope.isAllStudents = false;
            //[Object] - List of student Ids
            let list = [];
            _.each($scope.groupList, function(group) {
                group.isSelected = !$scope.isAllGroups;
                if (group.isSelected)
                    list.push({
                        _id: group._id
                    })
            })
            $scope.selectedGroupList = list;
            $scope.selectedStudentList = [];
        }

        $scope.groupSelected = (group, index) => {
            $scope.isServerCall = true;
            $scope.isAllStudents = false;
            $scope.selectedStudentList = [];
            if (!group.isSelected) {
                if ($scope.selectedGroupList.findIndex(i => i._id === group._id) == -1)
                    $scope.selectedGroupList.push({
                        _id: group._id
                    });
            } else
                $scope.selectedGroupList = _.without($scope.selectedGroupList, _.findWhere($scope.selectedGroupList, {
                    _id: group._id
                }))
            if ($scope.selectedGroupList.length == $scope.groupList.length)
                $scope.isAllGroups = true
            else
                $scope.isAllGroups = false
        }

        $scope.assignGroupUsers = () => {
            let previousState = $scope.previousState;
            if (previousState.state === "") {
                previousState = localStorageService.get('assignUserHistory')
                localStorageService.clear('assignUserHistory')
            }
            if ($scope.selectedStudentList.length > 0 || $scope.selectedGroupList.length > 0) {
                if ($scope.selectedGroupList.length > 0) {
                    $scope.assignedUsers = {
                        type: "group",
                        list: $scope.selectedGroupList
                    }
                }
                if ($scope.selectedStudentList.length > 0) {
                    $scope.assignedUsers = {
                        type: "all",
                        list: $scope.selectedStudentList
                    }
                }
            } else {
                toastr.error("Select Students to assign")
                return false;
            }
            if ($scope.isServerCall) {
                let state_details = ["viewTeachingPlan", "wizard"]
                if (previousState.params.planId && previousState.params.resourceId) {
                    let assigneeDetails = {
                        tp_id: planId,
                        assigned_users: $scope.assignedUsers,
                        academic_details: authoring,
                        user_id: userId,
                        res_id:previousState.params.resourceId
                    }
                    console.log(assigneeDetails)
                    authService.callAPI(ASSIGN_USER_CONSTANT.API_UPDATE_RESOURCE_ASSIGNEE_DETAILS, "POST", assigneeDetails, function(response) {
                        if (response && response.result && response.result.data) {
                            toastr.success("Students assigned")
                            $state.go(previousState.state, previousState.params)
                        }

                    })
                }
                else if (previousState.params.planId && !previousState.params.resourceId) {
                    
                    let assigneeDetails = {
                        tp_id: planId,
                        assigned_users: $scope.assignedUsers,
                        academic_details: authoring,
                        user_id: userId
                    }
                    console.log(assigneeDetails)
                    authService.callAPI(ASSIGN_USER_CONSTANT.API_UPDATE_ASSIGNEE_DETAILS, "POST", assigneeDetails, function(response) {
                        if (response && response.result && response.result.data) {
                            toastr.success("Students assigned")
                            $state.go(previousState.state, previousState.params)
                        }
                    })
                }

            } else {
                $state.go(previousState.state, previousState.params)
            }

        }

        $scope.cancelAssignUser = () => {
            $state.go('viewTeachingPlan', {
                planId: planId
            })
        }

        $scope.createNewGroup = () => {
            $state.go('createGroup', {
                planId: planId,groupId:""
            })
        }

        $scope.toggleExpansion = function(accordianData, selectedData, index) {
            _.each(accordianData, function(data, dataIndex) {
                if (dataIndex != index)
                    data.expanded = false;
                else
                    data.expanded = !selectedData.expanded;
            })
        }

        /*
         * Function to open menu
         *
         * @return : null
         */
        $scope.openMenu = function($mdOpenMenu, ev) {
            let originatorEv = ev;
            $mdOpenMenu(ev);
        };

        $scope.editGroup = function(groupId) {
            $state.go('createGroup', {planId:planId, groupId:groupId})
        }

        $scope.deleteGroup = function(groupId) {
            var confirm = $mdDialog.confirm()
                .textContent('Do you want to delete Group?')
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function() {
                authService.callAPI(ASSIGN_USER_CONSTANT.API_DELETE_GROUP + groupId, "GET", {}, function(response) {
                    if (response && response.result && response.result.data) {
                        toastr.success("Student group deleted successfully")
                        getGroupList()
                        getAllStudents()
                    }
                })

            }, function() {});
        }

        this.$onDestroy = () => {

        }

    }
}

export default AssignUsers;



// WEBPACK FOOTER //
// ./src/app/authoring-tool/assignUsers/controllers/assignUserController.js